import { render, staticRenderFns } from "./_promises.vue?vue&type=template&id=44e6dc54"
import script from "./_promises.vue?vue&type=script&lang=js"
export * from "./_promises.vue?vue&type=script&lang=js"
import style0 from "./_promises.vue?vue&type=style&index=0&id=44e6dc54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports